import { toast } from 'react-toastify';

import { DEFAULT_REQUEST_ERROR_TEXT, RATE_LIMIT_ERROR_TEXT } from 'constants/common';

const HTTP_TOO_MANY_REQUESTS = 429;

/**
 * Picks the message to show for a failed apisauce response.
 * 429: backend message → RATE_LIMIT_ERROR_TEXT.
 * Others: backend message → backend errors → caller fallback → DEFAULT_REQUEST_ERROR_TEXT.
 */
export const errorMessageFromResponse = (response, fallback) => {
  const { message, errors } = response?.data || {};
  const backendMessage = typeof message === 'string' && message.trim() ? message : '';

  if (response?.status === HTTP_TOO_MANY_REQUESTS) return backendMessage || RATE_LIMIT_ERROR_TEXT;

  const backendErrors = Array.isArray(errors) ? errors.filter((error) => typeof error === 'string').join(', ') : errors;
  const backendErrorsText = typeof backendErrors === 'string' && backendErrors.trim() ? backendErrors : '';

  return backendMessage || backendErrorsText || fallback || DEFAULT_REQUEST_ERROR_TEXT;
};

export const toastErrorMessage = (message) => {
  // toastId = message → identical errors fired in a burst (e.g. feedback auto-submit) show once
  toast.error(message, { hideProgressBar: true, theme: 'colored', toastId: message });
};

export const toastApiError = (response, fallback) => {
  toastErrorMessage(errorMessageFromResponse(response, fallback));
};
